import { useRouter } from "next/dist/client/router";
import React from "react";
import { useOverlaySettings } from "../hooks/useOverlaySettings";

const WaitForConfig = ({ Component, overlayType }) => {
  const { query = {}, isReady } = useRouter();
  const { streamKey } = query;

  const wishlist = {};
  const params = {};

  if (overlayType === "wishlist") {
    wishlist.id = query.id;
  }

  const { data } = useOverlaySettings(
    { overlayType, streamKey, wishlist, params },
    { enabled: !!streamKey }
  );

  if (!isReady) return "Loading...";

  if (data) {
    return <Component {...data} streamKey={streamKey} />;
  }
  return "Loading...";
};

export { WaitForConfig };
